export default {
  date: "7-02-25",
  additional_title: "Major Update",
  subtitle:
    "Catching up on all the improvements we've made to better serve you!",
  env_restriction: [],
  content: [
    {
      module: "🌟 Highlight: Portal Express",
      title:
        "Get certified in 15 minutes for LESS money! Our new Express service delivers:",
      updates: [
        "⚡ 15-minute turnaround (vs. 24 hours)",
        "💰 Lower prices (Quick-Cert: $60, Sure-Cert: $80)",
        "🤖 AI-powered automation",
        "♾️ Unlimited restamps"
      ]
    },
    {
      module: "🚀 New Features",
      title: "Portal Express - AI-Powered Certification (NEW!)",
      subtitle:
        "We're thrilled to introduce Portal Express, our revolutionary AI and automation-powered service for residential solar installations:",
      updates: [
        "⚡ 15-minute turnaround guarantee (vs. 24 hours standard)",
        "💰 Lower prices - save money while getting faster service!",
        "Free training course available through Teachable",
        "Complete training and submit your planset templates for engineering review",
        "Once approved, unlock Express addon for Quick-Cert and Sure-Cert services",
        "Automated design criteria population based on project location",
        "Unlimited restamps with the ability to modify values"
      ]
    },
    {
      title: "Stamping Profiles",
      subtitle: "Save time with every submission:",
      updates: [
        "Create state-specific stamp placement profiles",
        "Set your preferred XY coordinates once",
        "Automatic stamp placement on all future submissions",
        "Ensure uniform stamping across all your projects"
      ]
    },
    {
      title: "Direct Electrical Engineering Integration",
      updates: [
        "Full vendor onboarding complete",
        "Direct communication with electrical engineering teams",
        "No more middleman delays",
        "Dedicated vendor profiles for transparency"
      ]
    },
    {
      module: "🏷️ Service Rebranding",
      subtitle:
        "We've given our services new names that better reflect their value:",
      updates: [
        '"IEBC Letter" → "Quick-Cert" - Fast certification when you need it',
        '"Full Structural Calculations" → "Sure-Cert" - Comprehensive calculations you can trust'
      ]
    },
    {
      module: "🎨 UI/UX Improvements",
      title: "Enhanced Search and Filtering",
      updates: [
        "All search filters upgraded from basic dropdowns to intelligent, searchable multi-select fields",
        "Type to find what you need",
        "Select multiple options in one field",
        "Works across all filter types"
      ]
    },
    {
      title: "New Project List Sorting",
      updates: [
        'Added "Show by Recently Updated" sort option',
        "Quickly find projects with recent activity",
        "Original chronological sort still available"
      ]
    },
    {
      title: "Clearer Project Status Indicators",
      updates: [
        "Green truck icon shows when wet-stamped documents have shipped",
        "More specific activity log descriptions for better project tracking"
      ]
    },
    {
      module: "🔄 Workflow Improvements",
      title: "Dedicated Action Buttons",
      subtitle:
        "No more guessing! We've added clear buttons for common actions:",
      updates: [
        "Restamp Button - Request restamps with one click (replaces file upload method)",
        "Post Install Button - Clear process for post-installation requests"
      ]
    },
    {
      module: "🏷️ Service Rebranding",
      subtitle:
        "We've given our services new names that better reflect their value:",
      updates: [
        '"IEBC Letter" → "Quick-Cert" - Fast certification when you need it',
        '"Full Structural Calculations" → "Sure-Cert" - Comprehensive calculations you can trust'
      ]
    },
    {
      title: "Smarter Project Routing",
      subtitle: "Projects now follow optimized workflows:",
      updates: [
        "Electrical-only: Direct to electrical vendors",
        "Express + Electrical: Structural (PZSE) → Electrical",
        "Standard + Electrical: Electrical → Structural (PZSE)"
      ]
    },
    {
      title: "Post Install Enhancements",
      updates: [
        "Now available for both structural AND electrical engineering",
        "Electrical post installs include vendor checklist",
        'Projects must be in "Completed" status to request',
        "Choose one type at a time (structural OR electrical)"
      ]
    },
    {
      module: "💰 Pricing Updates",
      title: "Complete Pricing Structure"
    },
    {
      title: "Quick-Cert Services",
      updates: [
        "Standard: $80 (24-hour turnaround)",
        "Express: $60 (15-minute turnaround) 🎉",
        "Post Install Structural: FREE",
        "Post Install Electrical: $150"
      ],
      footer: "Express services are both faster AND more affordable!"
    },
    {
      title: "Wet Stamp Shipping (Upcoming Change)",
      subtitle: "Important: We're updating our wet stamp shipping structure:",
      updates: [
        "Current: $45 one-time fee for unlimited shipments per project",
        "New: $45 per shipment",
        "This ensures fair pricing for all users and reflects actual shipping costs"
      ]
    },
    {
      title: "Electrical Post Install Pricing",
      subtitle: "Important: We're updating our wet stamp shipping structure:",
      updates: [
        "Updated to reflect actual vendor costs",
        "Old price: $25",
        "New price: $150",
        "Includes comprehensive vendor checklist and review"
      ]
    },
    {
      module: "📚 Training and Resources",
      updates: [
        'New "Training and Resources" section in your profile',
        "Access to Express training course",
        "Additional resources coming soon"
      ]
    },
    {
      module: "🛡️ Express Service Requirements",
      title:
        "To maintain quality and safety standards, Express services require:",
      updates: [
        "Completion of free training course",
        "Planset template approval by PZSE engineering team",
        "Agreement to Client Responsibility Statement",
        "Accurate project data input"
      ]
    },
    {
      title: "Express Design Criteria",
      updates: [
        "Auto-populated conservative values for safety",
        "Editable with restrictions:",
        "✅ Can increase values (e.g., higher wind speeds)",
        "❌ Cannot decrease below engineering minimums",
        "Always defaults to most recent building codes"
      ]
    }
  ]
};
